<template>
  <div class="mobile-login">
    <div style="width:94%;max-width: 500px;background-color: #ffffff;margin-top: 7vh;"
         v-loading="loading">
      <div class="login-box">
        <div style="display:flex;align-items:center;justify-content:center;">
          <img :src="bath_path+'img/logo_108.png'"
               style="width: 38px;" />
          <div style="font-size: 38px;letter-spacing: 1px;font-weight: 500;color: #42c3af;margin-left: 8px;">薪火数据</div>
        </div>
        <div style="margin-top: 50px;padding: 30px 0;">
          <div style="text-align: center;font-size: 14px;color: #808080;">密码登录</div>
          <div class="input-form">
            <div class="input-box">
              <el-input v-model="loginAccount"
                        :maxlength="11"
                        @keyup.enter.native="$refs.pass.focus()"
                        placeholder="请输入您的手机号码">
                <i slot="prefix"
                   class="iconfont icon-yonghu"></i>
              </el-input>
            </div>
            <div class="input-box">
              <el-input ref="pass"
                        v-model="loginPassword"
                        show-password
                        @keyup.enter.native="$refs.yzm.focus()"
                        placeholder="请输入登录密码">
                <i slot="prefix"
                   class="iconfont icon-lock-full"></i>
              </el-input>
            </div>
            <div style="display:flex;align-items:center;">
              <div class="input-box"
                   style="flex:1;">
                <el-input v-model="loginYzm"
                          :maxlength="4"
                          ref="yzm"
                          @keyup.enter.native="login()"
                          placeholder="请输入验证码">
                  <i slot="prefix"
                     :style="{ color: identifyStatus ? '#42c3af' : '' }"
                     class="iconfont icon-yanzhengma-xuanzhong"></i>
                </el-input>
              </div>
              <div style="margin-left:10px;margin-top:30px;cursor: pointer;"
                   @click="refreshCode">
                <identify ref="identify"
                          :identifyCode="identifyCode"></identify>
              </div>
            </div>
            <div style="display:flex;align-items:center;margin-top:25px;padding:0 6px;">
              <el-checkbox v-model="agrement"></el-checkbox>
              <div style="margin-left:6px;">同意并遵守<a target="_self"
                   rel="noopener noreferrer"
                   href="https://datainside.com.cn/protocol/?mobile=1"
                   class="link">{{ '《用户协议》' }}</a>和<a target="_self"
                   href="https://datainside.com.cn/yszc/?mobile=1"
                   rel="noopener noreferrer"
                   class="link">{{ '《隐私政策》' }}</a></div>
            </div>
            <div style="margin-top:20px;display:flex;justify-content:center;padding:0;">
              <el-button type="primary"
                         :disabled="!canLogin"
                         @click="login"
                         style="flex:1;border-radius: 25px;">{{ loading ?
              '正在登录...' : '登录' }}<i v-show="loading"
                   style="margin-left: 10px;"
                   class="el-icon-loading"></i></el-button>
            </div>
            <div class="more-box">
              <span @click="toRegister"
                    style="cursor: pointer;">没有账号，立即注册</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import identify from '@/components/identify';
export default {
  components: { identify },
  name: 'MobileAuth',
  data () {
    return {
      bath_path: process.env.BASE_URL,
      loading: false,
      loginAccount: '',
      loginPassword: '',
      loginYzm: '',
      identifyCode: '',
      identifyCodes: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'], //根据实际需求加入自己想要的字符
      agrement: false,
    }
  },
  computed: {
    canLogin () {
      if (this.loginAccount && this.loginPassword && this.loginYzm && this.identifyStatus) {
        return true;
      } else {
        return false;
      }
    },
    identifyStatus () {
      return this.loginYzm.toUpperCase() === this.identifyCode.toUpperCase();
    }
  },
  mounted () {
    this.refreshCode();
  },
  methods: {
    login () {
      if (this.loginAccount == '' || this.loginPassword == '') {
        this.$message.error('请输入账户密码！');
        return;
      }
      if (!this.identifyStatus) {
        this.$message.error('验证码错误！');
        return;
      }
      if (!this.agrement) {
        this.$message.info('请阅读并同意《用户协议》和《隐私政策》！');
        return;
      }
      this.loading = true;
      this.refreshCode();
      this.loginYzm = '';
      let param = {
        username: this.$aes.encrypt(this.loginAccount),
        password: this.$aes.encrypt(this.loginPassword)
      };
      this.$request.post('api/Platform/IntegrationUserAuth/UamAuths/', param).then((response) => {
        this.loading = false;
        if (response.code === '000000') {
          this.openBIUrl(response.data.links);
        } else {
          this.$message.error(response.message);
        }
      })
        .catch((e) => {
          this.loading = false;
          this.$message.error("连接失败！请重试！");
        });
    },
    openBIUrl (links) {
      if (links && links.length > 0) {
        window.location.href = links[0].url + '?isdialog=1';
      } else {
        alert('没有可使用的系统!');
      }
    },
    // 生成随机数
    randomNum (min, max) {
      max = max + 1
      return Math.floor(Math.random() * (max - min) + min);
    },
    // 更新验证码
    refreshCode () {
      this.identifyCode = "";
      this.makeCode(4);
    },
    // 随机生成验证码字符串
    makeCode (len) {
      let cc = '';
      for (let i = 0; i < len; i++) {
        let c1 = this.identifyCodes[this.randomNum(0, this.identifyCodes.length - 1)];
        cc += c1.toUpperCase();
      }
      this.identifyCode = cc;
    },
    toRegister () {
      this.$router.push('/mobileregister')
    }
  }
}
</script>

<style lang="scss">
a.link {
  text-decoration: none;
}

a.link,
a.link:hover {
  color: #42c3af;
}

a.link:hover {
  text-decoration: underline;
}

.mobile-login {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  background-color: #ffffff;
  justify-content: center;

  .more-box {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    font-size: 14px;
    color: #42c3af;
    padding: 0 10px;

    span:hover {
      text-decoration: underline;
    }
  }

  .input-form {
    padding: 10px 20px;

    .login-btn {
      flex: 1;
      background-color: #42c3af;
      color: #ffffff;
      cursor: pointer;
      line-height: 42px;
      border-radius: 25px;
      font-size: 18px;
    }

    .login-btn-disabled {
      background-color: #c6c9fc;
      color: #ffffff;
      cursor: not-allowed;
    }

    .input-box {
      margin-top: 30px;
      // display: flex;
      // align-items: center;
    }

    .input-box .el-input__inner {
      letter-spacing: 1px;
      font-size: 14px;
      padding-left: 45px;
      padding-right: 20px;
      border-radius: 25px;
      background-color: #f7f8fa;
    }

    .input-box .el-input__prefix {
      left: 20px;
      line-height: 40px;
    }
  }

  .tab-bar-item {
    line-height: 40px;
    border-bottom-width: 2px;
    font-size: 15px;
    color: #999;
    cursor: pointer;
    border-bottom-style: solid;
    border-bottom-color: transparent;
  }

  .tab-bar-item-active {
    color: #333;
    border-bottom-color: #42c3af;
  }

  .tab-bar-item + .tab-bar-item {
    margin-left: 40px;
  }

  .login-box {
    text-align: center;
    padding: 0px 10px;
  }
}
</style>
